<template>
  <div>
    <!-- controls-->
    <div class="text-start">
      <div class="btn-group">
        <button class="btn btn-sm btn-outline-primary">All</button>
        <button class="btn btn-sm btn-outline-primary">Found</button>
        <button class="btn btn-sm btn-outline-primary">Missing</button>
      </div>
    </div>

    <!-- list -->
    <div>
      [[]]
      {{ contentMap }}
      <div
        class="row d-flex justify-content-between border border-bottom border-secondary"
        v-for="(value, key) in filteredList"
        :key="key"
      >
        <div class="col text-start">
          {{ key }}
        </div>
        <div class="col text-start text-truncate">
          {{ value }}
        </div>
      </div>
    </div>
    [[]]

    <!-- other -->
    <hr />
    <div class="row">
      <div class="col-8 text-start">
        <b>Content Found</b>
        <hr />
        <div
          :key="key"
          v-for="{ key, value } in keysFound"
          class="row d-flex justify-content-between"
        >
          <div class="col">{{ key }}</div>
          <div class="col text-truncate">{{ value }}</div>
        </div>
      </div>
      <div class="col text-start">
        <b>Content Missing</b>
        <hr />
        <div
          :key="key"
          v-for="{ key } in keysMissing"
          class="row d-flex justify-content-between"
        >
          <div>{{ key }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useContentStore } from "@/dev/store/useContentStore.js";
import { mapState } from "pinia";
export default {
  name: "TheContentManager",
  computed: {
    ...mapState(useContentStore, ["keysFound", "keysMissing", "contentMap"]),
    filteredList() {
      let list = this.contentMap;
      //list = list.filter;

      return list;
    }
  }
};
</script>
